export default function SuperAdminPanel() {
  return <h1>Welcome, Super Admin</h1>;
}
